//-----------------------------
// | HELPER to understand the logic behind consents
// |
// | US pages ALL - Tier1 and Tier3
// | universalConsent - {type: "termsAndConditions", accepted: true} -- ALWAYS true by clicking submit
// |
// | ccpa
// | {type: "ccpa-agree-terms-and-privacy", accepted: true}  -- Only for California ZIP
// | {type: "ccpa-consent-to-share-pii", accepted: true}  -- Only for California ZIP
// |
// | CA tier1
// | { type: 'universal-marketing',accepted: true }   -- ALWAYS true for Tier 1
// | { type: 'dealer-marketing',   accepted: false }  -- From CFM
// | { type: 'oem-marketing', accepted: false }  -- From CFM
// |
// | CA tier 3
// | {type: "universal-marketing", accepted: false}  --  ALWAYS false for Tier 1
// | {type: "dealer-marketing", accepted: true}  -- From CFM
// | {type: "oem-marketing", accepted: true}  -- From CFM

type ConsentsTypes = {
  universal: boolean;
  ccpa: boolean;
  tcpa: boolean;
  dealer: boolean;
  oem: boolean;
};

const consentProcessor = (isTier3: boolean, isUSMarket: boolean, consents: ConsentsTypes) => {
  const { universal, ccpa, tcpa, dealer, oem } = consents;

  let universalConsent;

  if (process.env.IS_LEGACY) {
    universalConsent = isUSMarket ? { type: 'termsAndConditions', accepted: true } : undefined;
  }

  universalConsent = universal ? { type: 'termsAndConditions', accepted: true } : undefined;
  const ccpaConsent = ccpa
    ? [
        { type: 'ccpa-agree-terms-and-privacy', accepted: true },
        { type: 'ccpa-consent-to-share-pii', accepted: true },
      ]
    : [];
  const tcpaConsent = tcpa ? { type: 'TCPAConsent', accepted: true } : undefined;
  const dealerConsent = dealer ? { type: 'dealer-marketing', accepted: true } : undefined;
  const oemConsent = oem ? { type: 'oem-marketing', accepted: true } : undefined;

  const universalMarketingConcent = !isUSMarket
    ? { type: 'universal-marketing', accepted: !isTier3 }
    : undefined;

  const finalConsentList = [
    universalConsent,
    tcpaConsent,
    dealerConsent,
    oemConsent,
    universalMarketingConcent,
    ...ccpaConsent,
  ].filter((toCheck) => toCheck);

  return finalConsentList;
};
export default consentProcessor;
